export default Object.freeze({
  //API_URL: "http://127.0.0.1:8000/api/v1",
  API_URL: "https://www.yt-project.xyz/api/v1",
  API_KEY: "AIzaSyBSwmKOv_EHOHGS-PZM57XyrrdVLgvf8Sc"
});
